import { render, staticRenderFns } from "./font-awesome-icon.vue?vue&type=template&id=8cae05c6"
import script from "./font-awesome-icon.ts?vue&type=script&lang=ts&external"
export * from "./font-awesome-icon.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports